import rsu from "./rsu";
import tim from "./tim";
import fvu from "./fvu";
import tsc from "./tsc";
import ess from "./ess";
import fvu_monitor from "./fvu_monitor";
import deviceManager from "./device-manager";
import totalStation from "./total_station";
import deviceScr from "./device-scr";
import intersection from "./intersection";
import vu_approach_location from "./vu_approach_location";
import spatVerificationModule from "./spat-verification";
import motModule from "./mot";

export default {
	[deviceManager.MODULE_NAME]: deviceManager,
	[totalStation.MODULE_NAME]: totalStation,
	[spatVerificationModule.MODULE_NAME]: spatVerificationModule,
	[motModule.MODULE_NAME]: motModule,
	rsu,
	tim,
	fvu,
	fvu_monitor,
	tsc,
	ess,
	deviceScr,
	intersection,
	vu_approach_location
};
